import { buildOptions, getEndPoint } from '../../../utils/api-call';
import constants from './constants';
import { makeCall } from '../../../utils/request';

const updateSettings = ({commit, state, dispatch}, data) => {
  return new Promise((resolve, reject) => {
    makeCall(getEndPoint().settings.updateValidator, buildOptions('POST', data))
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });
};

export default {
  [constants.ACTION_UPDATE_SETTINGS]: updateSettings
};



// WEBPACK FOOTER //
// ./src/store/modules/setting/actions.js